import React from 'react';
import {
  FormPageMainContent,
  FormPageMainContentProps,
} from '../FormPageMainContent';

export interface SettingsPageMainContentProps
  extends FormPageMainContentProps {}

export function SettingsPageMainContent(props: SettingsPageMainContentProps) {
  return <FormPageMainContent {...props} />;
}

SettingsPageMainContent.displayName = 'SettingsPageMainContent';
